import { useState, useEffect } from "react";

export function useSearchParamsState(searchParamName, defaultValue) {
  const [value, setValue] = useState(() => {
    if (typeof window === 'undefined') return defaultValue;

    const searchParams = new URLSearchParams(window.location.search);
    if (searchParamName.includes('[]')) {
      const values = searchParams.getAll(searchParamName).map(decodeURIComponent);
      return values.length > 0 ? values : defaultValue;
    }

    const param = searchParams.get(searchParamName);
    return param ? decodeURIComponent(param) : defaultValue;
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParamName.includes('[]') && Array.isArray(value)) {
      searchParams.delete(searchParamName);
      value.forEach(val => searchParams.append(searchParamName, encodeURIComponent(val)));
    } else {
      if (value === defaultValue) {
        searchParams.delete(searchParamName);
      } else {
        searchParams.set(searchParamName, encodeURIComponent(value));
      }
    }

    const newSearch = searchParams.toString();
    const newUrl = newSearch ? `${window.location.pathname}?${newSearch}` : window.location.pathname;

    window.history.replaceState(null, '', newUrl);
  }, [value, searchParamName, defaultValue]);

  return [value, setValue];
}
